export default "__VITE_ASSET__DTPNmJxu__"